import type { VirtualAppointmentOverviewPerson } from '../../../services/virtualAppointmentsOverview';
import { MISSING_VALUE } from './missingValue.ts';

export interface PersonDisplay {
    label: string;
    title?: string;
}

// The name reads best; the email stays reachable as a tooltip, and stands in when there's no name.
export function formatPerson(person: VirtualAppointmentOverviewPerson | null): PersonDisplay {
    if (!person) return { label: MISSING_VALUE };
    const name = person.name?.trim();
    return name ? { label: name, title: person.email } : { label: person.email };
}
